export default "__VITE_ASSET__C8YTlrR3__"